import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from 'modules';
import {getVodInfoAsync} from 'modules/vodInfo';
import {setInitListAction} from 'modules/file';
import {isChatAction, editModeAction} from 'modules/ui';
// import { getLoginId } from "lib/utils";
import {TRANSCODING_FLAG, LOGIN_AFREECATV_DOMAIN} from 'constants/config';
import TitleContainer from 'containers/common/TitleContainer';
import VideoContainer from 'containers/player/VideoContainer';
import ScreenContainer from 'containers/player/ScreenContainer';
import ChatContainer from 'containers/player/chat/ChatContainer';
import EditModeContainer from 'containers/edit/EditModeContainer';
// import EditStatusContainer from "containers/edit/EditStatusContainer";
import EditAreaContainer from 'containers/edit/EditAreaContainer';
import PlayerTemplate from 'components/player/PlayerTemplate';
import PlayerInfo from 'components/player/PlayerInfo';
import ControlBar from 'components/player/controlbar/ControlBar';
import DragEditorSize from 'components/DragEditorSize';
import EditTemplate from 'components/edit/EditTemplate';
import EditTitleWrap from 'components/edit/EditTitleWrap';
import Loading from 'components/common/modal/Loading';
import {t} from 'lib/i18n';

interface IVodInfoProps {
  titleNo: number;
  mode: string;
}

const VodInfoContainer = ({titleNo, mode}: IVodInfoProps) => {
  const dispatch = useDispatch();
  const {data, loading, error} = useSelector(
    (state: RootState) => state.vodInfo.titleFileInfo,
  );
  const {uiState} = useSelector(({ui: uiState}: RootState) => ({
    uiState,
  }));

  /**
   * VOD / 파일 정보 가져옴
   */
  useEffect(() => {
    dispatch(getVodInfoAsync.request({titleNo, mode}));
    dispatch(editModeAction(mode)); // 에디트 모드 리덕스로 설정
  }, [dispatch]);

  /**
   * VOD 파일 정보 호출 후 타는 함수
   */
  useEffect(() => {
    if (data) {
      const {result, message, response} = data;

      if (result === -4) {
        // 비로그인
        const url = window.location.href; // 현재 URL
        window.location.href = `${LOGIN_AFREECATV_DOMAIN}/afreeca/login.php?szFrom=full&request_uri=${encodeURIComponent(
          url,
        )}`;
        return;
      }

      if (result !== 1 && result !== TRANSCODING_FLAG) {
        alert(message);
        window.history.back();
        return;
      }

      if (!response.files) return;

      dispatch(setInitListAction(response.files));

      const elements = document.querySelectorAll('.webeditor_contents');
      elements.forEach(function (element) {
        element.setAttribute('dark', 'true');
      });
    }
  }, [data]);

  /**
   * 채팅창 보이기 클릭 함수
   */
  const onClickOpenChat = (
    e:
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
      | React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault();
    dispatch(isChatAction(true));
  };

  return (
    <div className='webeditor_contents'>
      {loading && <Loading />}
      {error && alert(t('시스템 오류!! 잠시후 다시 시도해주세요.'))}
      {data && data.result === TRANSCODING_FLAG && (
        <Loading text={data.message} isBtn={true} />
      )}
      {data && data.result === 1 && (
        <>
          <TitleContainer />
          {/* <Title title={data.response.info.title_name} /> */}
          <PlayerTemplate
            info={
              <PlayerInfo
                title={data.response.info.title_name}
                nickname={data.response.info.user_nick}
                readCnt={data.response.info.read_cnt}
                onClickOpenChat={onClickOpenChat}
              />
            }
            onClickOpenChat={onClickOpenChat}
            video={<VideoContainer />}
            control={<ControlBar />}
            screen={<ScreenContainer />}
            chat={<ChatContainer />}
            isChat={uiState.isChat}
          />
          <DragEditorSize isChat={uiState.isChat} />
          <EditTemplate>
            <EditModeContainer />
            {/* <EditStatusContainer /> */}
            <EditTitleWrap />
            <EditAreaContainer />
          </EditTemplate>
        </>
      )}
    </div>
  );
};

export default VodInfoContainer;
